<div (click)="copy()" style="cursor: pointer; display: flex; flex-direction: column">
  Er ging iets mis
  <span style="font-size: 0.85em"
    >Foutcode: <b>{{ toastRef.data.code }}</b></span
  >
  <small style="opacity: 0.7; margin-top: 4px"
    >Klik om de volledige fout-referentie te kopiëren</small
  >
</div>
